// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__Pn8zA","layout-body":"style_layout-body__DgcC_"};